import { c as _c } from "react/compiler-runtime";
export interface MetricDisplayProps {
  amount: string;
  currency: string;
  unit: string;
}
function MetricDisplay(t0) {
  const $ = _c(12);
  const {
    amount,
    currency,
    unit
  } = t0;
  let t1;
  if ($[0] !== amount) {
    t1 = <span className="text-3xl/[120%] font-bold">{amount}</span>;
    $[0] = amount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currency) {
    t2 = <span className="text-foreground/50 text-xs/4.5 font-medium">{currency}</span>;
    $[2] = currency;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== unit) {
    t3 = <span className="text-xs/4.5 font-medium">{unit}</span>;
    $[4] = unit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-0">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-2">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export { MetricDisplay };